import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getdutytariffLibAsync = createAsyncThunk(
  'libraries/dutyandtariff',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/tariff', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getdutytariffCountriesAsync = createAsyncThunk(
  'libraries/dutyandtariff/countries',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/tariff/country', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getdutytariffTotalCountAsync = createAsyncThunk(
  'libraries/dutyandtariff/total-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/tariff/getTotalCount', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getdutytariffDestinationCountriesAsync = createAsyncThunk(
  'libraries/dutyandtariff/destination-countries',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/tariff/getDestinationCountry', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const downloaddutytariffAsync = createAsyncThunk(
  'libraries/dutyandtariff/download',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/tariff/downloadTariffExcel', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDutyTariffLastUpdatedDateAsync = createAsyncThunk(
  'libraries/dutyandtariff/get-last-updated-date',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/tariff/getUpdatedDate', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
